import { useCallback, useMemo } from 'react';

import { Trash } from 'lucide-react';
import { ButtonIcon, DefaultTable } from 'twyne-new.ui'

import MergetagInput from '@Components/formsy/MergetagInput'
import { getDateFormats } from 'utils';

import { useOfferStore } from '../store';

export default function Pixel({ pixels = [], onChange }) {
  const { lists: { customFields: { items, useLoad }, 'meta-fields': { items: metaFields, useLoad: useLoadMetaFields } } } = useOfferStore()

  useLoad()
  useLoadMetaFields()

  const mergetags = useMemo(() => {
    const mergetags = [...MERGETAGS]

    for (const { key, type, private: isPrivate } of items || []) {
      if (isPrivate) continue;
      mergetags.push(`cf_${key}`)
      if (type === 'date') {
        mergetags.push(...getDateFormats(key).map(format => `cf_${format}`))
      }
    }

    for (const { key } of metaFields || []) {
      mergetags.push(key)
    }

    return mergetags
  }, [items, metaFields])

  const handleRemove = useCallback(position => {
    pixels.splice(position, 1)
    onChange([...pixels])
  }, [pixels, onChange])

  const handleChange = useCallback((position, key, value) => {
    pixels[position][key] = `${value}`.trim()
    onChange(pixels)
  }, [pixels, onChange])

  const columns = [{
    dataField: '',
    text: 'URL',
    headerClassName: 'w-full',
    formatter: (_, pixel, index) => <>
      <MergetagInput required name={`url.${index}`} value={pixel.url}
        mergetags={mergetags} onChange={value => handleChange(index, 'url', value)} />
    </>,
  }, {
    dataField: '',
    text: '',
    className: 'w-8',
    formatter: (_, row, index) => <ButtonIcon
      content="Delete"
      onClick={() => handleRemove(index)}
    >
      <Trash size={16} />
    </ButtonIcon>,
  }]

  return <>
    <DefaultTable
      data={pixels}
      columns={columns}
      noDataIndication={() => 'No content to show.'}
      className='max-h-[33vh] overflow-y-auto'
    />
  </>
}

const MERGETAGS = [
  "user_id",
  "first_name",
  "last_name",
  "email",
  "address1",
  "address2",
  "city",
  "state",
  "zip",
  "country",
  "gender",
  "optout",
  "test",
  "age",
  "dob",
  "dob_dd",
  "dob_yyyy",
  "dob_slashes_mmddyyyy",
  "dob_yyyyddmm",
  "dob_dashes_mmddyyyy",
  "phone",
  "phone_areaCode",
  "phone_prefix",
  "phone_suffix",
  "sessionid",
  "usessionid",
  "user_session_id",
  "site_id",
  "publisher_id",
  "allocation_id",
  "sid1",
  "sid2",
  "sid3",
  "form_id",
  "post_id",
  "offer_id",
  "post_target_id",
  "externalid",
  "campaignid",
  "payouttype",
  "cost",
  "conversiontype",
  "converted",
  "duplicated",
  "email_verification",
  "fraud_verification",
  "postal_verification",
  "phone_verification",
  "bot_verification",
  "is_bot",
  "tcpaconsent",
  "registration_consent",
  "registration_completed",
  "leadid_cert",
  "trustedform_cert",
  "referrer",
  "device",
  "os",
  "browser",
  "useragent",
  "ipaddress",
  "ip_state",
  "ip_city",
  "ip_zip",
  "url_param_value()",
  "md5()",
  "lower()",
  "upper()",
  "capitalize()",
]
